import React from 'react';

// Filet de sécurité : une erreur JavaScript n'affiche jamais une page blanche
export class AppErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { error: null };
  }

  static getDerivedStateFromError(error) {
    return { error };
  }

  componentDidCatch(error, info) {
    import('../lib/clientLog').then(({ logClientError }) => logClientError({
      kind: 'react_error', message: `${error?.message || error} ${(info?.componentStack || '').slice(0, 300)}`,
    })).catch(() => {});
  }

  render() {
    if (!this.state.error) return this.props.children;
    return (
      <div className="min-h-screen bg-zinc-950 text-white flex flex-col items-center justify-center gap-4 px-6 text-center" data-testid="app-error-fallback">
        <img src="/logos/logo-ledzone-header.png" alt="LED ZONE" className="h-8 w-auto mb-4" />
        <p className="text-lg font-semibold">{this.props.message || "La page n'a pas pu être affichée"}</p>
        <p className="text-sm text-zinc-400 max-w-sm">Un problème technique est survenu. Réessayez, ou contactez-nous au 032 730 44 45.</p>
        <div className="flex flex-wrap justify-center gap-3">
          <button onClick={() => window.location.reload()} className="h-11 px-6 rounded-lg bg-amber-500 text-black font-bold hover:bg-amber-400" data-testid="app-error-retry">Réessayer</button>
          <a href="/?page=boutique" className="h-11 px-6 rounded-lg border border-zinc-600 flex items-center hover:border-zinc-400" data-testid="app-error-shop">Voir la boutique</a>
        </div>
      </div>
    );
  }
}
